<form [formGroup]="form" (submit)="submit()" a11yFocusTrap>
  <vwui-modal-header>
    <h2 a11yPageTitleLevel="2">{{ title | translate }}</h2>
  </vwui-modal-header>
  <vwui-modal-body a11yAutoFocus>

      <vwui-form-group [label]="'COMPONENT.project_analysis.modal.question.field.title' | translate" inputId="title">
          <vwui-input inputId="title" formControlName="title" [required]="true"></vwui-input>
      </vwui-form-group>

      <vwui-form-group [label]="'COMPONENT.project_analysis.modal.question.field.question' | translate" inputId="question">
          <vwui-input inputId="question" formControlName="question" [maxlength]="1025"></vwui-input>
      </vwui-form-group>

      <vwui-form-group [label]="'COMPONENT.project_analysis.modal.question.field.info' | translate" inputId="info">
          <vwui-input inputId="info" formControlName="info" [maxlength]="1025"></vwui-input>
      </vwui-form-group>

    <div class="grid">
      <vwui-checkbox inputId="allowAttachments" formControlName="allowAttachments" class="grid__col">
        {{ 'COMPONENT.tis.modal.create_question.field.allowAttachments' | translate }}
      </vwui-checkbox>

      <vwui-checkbox inputId="isRequired" formControlName="isRequired" class="grid__col">
        {{ 'COMPONENT.project_analysis.modal.question.field.isRequired' | translate }}
      </vwui-checkbox>

      <vwui-checkbox inputId="isQuickScan" formControlName="isQuickScan" class="grid__col">
            {{ 'COMPONENT.project_analysis.modal.question.field.isQuickScan' | translate }}
      </vwui-checkbox>

      <vwui-checkbox inputId="showExplanation" formControlName="showExplanation" class="grid__col">
            {{ 'COMPONENT.project_analysis.modal.question.field.showExplanation' | translate }}
      </vwui-checkbox>

        <vwui-checkbox inputId="isMultiAnswer" formControlName="isMultiAnswer" class="grid__col">
            {{ 'COMPONENT.project_analysis.modal.question.field.isMultiAnswer' | translate }}
        </vwui-checkbox>
    </div>

      <vwui-form-group [label]="'COMPONENT.quickscan.modal.create_question.field.pit_tag' | translate" inputId="pitTag">
          <ng-select
              class="library-items"
              [items]="pitOptions()"
              bindValue="id"
              bindLabel="label"
              [placeholder]="'COMPONENT.quickscan.modal.create_question.placeholder.pit_tags' | translate"
              formControlName="pitTag"
          >
          </ng-select>
      </vwui-form-group>

    <div class="horizontal-container" formGroupName="dependentQuestion">
      <vwui-form-group label="Afhankelijk van" class="horizontal-container__child--grow">
        <ng-select formControlName="tempId"
          [placeholder]="'COMPONENT.tis.modal.create_question.placeholder.dependentQuestion' | translate"
          [notFoundText]="'COMPONENT.tis.modal.create_question.notFound.dependentQuestion' | translate">
          @for (question of possibleDependentQuestions; track question) {
            <ng-option
            [value]="question.tempId">{{question.selectTitle}}</ng-option>
          }
        </ng-select>
      </vwui-form-group>

      @if (showDependentValueSelect) {
        <vwui-form-group label="Vereiste waarde"
          class="horizontal-container__child--grow">
          @switch (dependentQuestion.type) {
            @case (IQuestionType.MULTIPLECHOICE) {
              <ng-select formControlName="answerTempId"
                [placeholder]="'COMPONENT.tis.modal.create_question.placeholder.dependentAnswer' | translate">
                @for (option of dependentQuestionOptions; track option) {
                  <ng-option
                  [value]="option.tempId">{{option.answer}}</ng-option>
                }
              </ng-select>
            }
            @case (IQuestionType.BOOL) {
              <ng-select formControlName="boolValue" [placeholder]="'COMPONENT.tis.modal.create_question.placeholder.dependentBool' | translate">
                <ng-option [value]="true">{{'YES_OR_NO.yes' | translate}}</ng-option>
                <ng-option [value]="false">{{'YES_OR_NO.no' | translate}}</ng-option>
              </ng-select>
            }
          }
        </vwui-form-group>
      }
    </div>

    <div class="horizontal-container">
      <vwui-form-group [label]="'COMPONENT.tis.modal.create_question.field.questionType' | translate"
        inputId="type" class="horizontal-container__child--grow">
        <ng-select
          [items]="questionTypes"
          [selectOnTab]="true"
          [multiple]="false"
          [required]="true"
          bindValue="value"
          bindLabel="label"
          formControlName="type"
        ></ng-select>
      </vwui-form-group>

      @if (isText) {
        <vwui-form-group
          [label]="'COMPONENT.tis.modal.create_question.field.textAnswerLength' | translate"
          class="horizontal-container__child--grow">
          <vwui-input formControlName="textAnswerLength" type="number" [min]="1"
          [max]="maxTextAnswerLength"></vwui-input>
        </vwui-form-group>
      }
    </div>

    <div formArrayName="possibleAnswers" class="answers">
      @for (control of possibleAnswersFormArray.controls; track control; let index = $index) {
        <div [formGroupName]="index"
          class="answer">
          <vwui-input
            class="answer__input"
            formControlName="answer"
            [maxlength]="1025">
          </vwui-input>
          <ng-select formControlName="colorScore"
            class="answer__color_score_input"
            [items]="colorScores"
            bindValue="key"
            bindLabel="label"
            [searchable]="false">
          </ng-select>
          <vwui-input type="number" formControlName="score" class="answer__score_input"></vwui-input>
          @if (isConcept()) {
              <vwui-btn-icon icon="vwui-trash"
                tabindex="-1"
                [disabled]="possibleAnswersFormArray.controls.length <= minimumMultipleChoiceAnswers"
                (click)="removeAnswer(index)">
              </vwui-btn-icon>
          }
        </div>
        <div class="answer__library_items" [formGroupName]="index">
              <vwui-form-group [label]="'COMPONENT.quickscan.modal.create_question.field.library_items' | translate">
                  <ng-select
                      class="library-items"
                      formControlName="libraryEntryIds"
                      [items]="libraries"
                      bindValue="id"
                      bindLabel="title"
                      [compareWith]="compareEntry"
                      [placeholder]="'COMPONENT.quickscan.modal.create_question.placeholder.library_items' | translate"
                      multiple="true"
                  >
                  </ng-select>
              </vwui-form-group>
          </div>
      }
    </div>

    @if (isMultipleChoice) {
      <vwui-button class="add-answer-button is-secondary" (click)="addAnswer()" [disabled]="!isConcept()">
        {{ 'COMPONENT.tis.modal.create_question.add_question' | translate }}
      </vwui-button>
    }

    @if (isNumeric) {
        <div class="answer">
            <vwui-form-group
                [label]="'COMPONENT.project_analysis.modal.question.field.maxValue' | translate"
                class="answer__max_value_input">
                <vwui-input-mask type="text" inputmode="numeric" formControlName="maxValue" [mask]="integerMask"></vwui-input-mask>
            </vwui-form-group>
            <vwui-form-group
                [label]="'COMPONENT.project_analysis.modal.question.field.minValue' | translate"
                class="answer__min_value_input">
                <vwui-input-mask type="text" inputmode="numeric" formControlName="minValue" [mask]="integerMask"></vwui-input-mask>
            </vwui-form-group>
        </div>
    }

    @if (isCalculation) {
      <div class="horizontal-container" formGroupName="calculation">
        <ng-select formControlName="leftQuestionTempId" class="horizontal-container__child--grow">
          @for (question of integerQuestions; track question) {
            <ng-option
            [value]="question.tempId">{{question.title}}</ng-option>
          }
        </ng-select>
        -
        <ng-select formControlName="rightQuestionTempId" class="horizontal-container__child--grow">
          @for (question of integerQuestions; track question) {
            <ng-option
            [value]="question.tempId">{{question.title}}</ng-option>
          }
        </ng-select>
      </div>
    }

  </vwui-modal-body>

  <vwui-modal-footer>
    <vwui-button class="is-light" (click)="modalRef.close()">
      {{ 'BUTTON.cancel' | translate }}
    </vwui-button>
    <vwui-button class="is-primary" [loading]="loading" (click)="submit()" [disabled]="!isConcept()">
      {{ saveText | translate }}
    </vwui-button>
  </vwui-modal-footer>
</form>
